import { Link } from "@tanstack/react-router";
import { Button } from "@dishfolio/ui";

export function NotFound() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 p-10 text-center">
      <div className="font-display text-4xl font-semibold">404</div>
      <p className="text-muted-foreground">This page doesn’t exist.</p>
      <Button asChild variant="outline">
        <Link to="/">Back to dashboard</Link>
      </Button>
    </div>
  );
}
